// import images
import Logo from '../src/img/header/logo.svg';
import GalleryImg1 from '../src/img/gallery/1.png';
import GalleryImg2 from '../src/img/gallery/2.png';
import GalleryImg3 from '../src/img/gallery/3.png';
import GalleryImg4 from '../src/img/gallery/4.png';
import GalleryImg5 from '../src/img/gallery/5.png';
import GalleryImg6 from '../src/img/gallery/6.png';
import GalleryImg7 from '../src/img/gallery/7.png';
import GalleryImg8 from '../src/img/gallery/8.png';
import QuoteImg from '../src/img/testimonial/quote.svg';
// import icons
import { GrFacebookOption } from 'react-icons/gr';
import { IoMdArrowForward } from 'react-icons/io';
import { FiSend } from 'react-icons/fi';
import { FaPlay, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import {
  IoLogoInstagram,
  IoLogoPinterest,
  IoLogoTwitter,
  IoLogoYoutube,
} from 'react-icons/io';

export const headerData = {
  logo: Logo,
};

export const navData = {
  items: [
    { href: '/', name: 'Home' },
    { href: '/', name: 'About' },
    { href: '/', name: 'Gallery' },
    { href: '/', name: 'Interview' },
    { href: '/', name: 'Articles' },
    { href: '/', name: 'Contact' },
  ],
};

export const socialData = [
  { href: '/', icon: <GrFacebookOption /> },
  { href: '/', icon: <IoLogoInstagram /> },
  { href: '/', icon: <IoLogoPinterest /> },
  { href: '/', icon: <IoLogoTwitter /> },
  { href: '/', icon: <IoLogoYoutube /> },
];

export const heroData = {
  title: 'I’m Sourin.',
  subtitle:
    'Tattoos have their own unique power and magic. They not only beautify the body but also the psyche.',
  btnText: 'read more',
  btnIcon: <IoMdArrowForward />,
};

export const aboutData = {
  title: 'My Story:',
  subtitle1:
    'Lorem ipsum dolor sit amet. Et consequatur quis est quia voluptatibus qui iure assumenda. Quo autem dolores et dolorem nihil ut necessitatibus maiores id neque sunt. Est totam fugiat id delectus consequuntur et beatae galisum sed doloribus consequatur ut nesciunt magni ex autem alias.',
  subtitle2:
    'Lorem ipsum dolor sit amet. Et consequatur quis est quia voluptatibus qui iure assumenda. Quo autem dolores et dolorem nihil ut necessitatibus maiores id neque sunt. Est totam fugiat id delectus consequuntur et beatae galisum sed doloribus consequatur ut nesciunt magni ex autem alias.',
  btnText: 'Know more',
  btnIcon: <IoMdArrowForward />,
};

export const galleryData = {
  title: 'Check my gallery:',
  btnText: 'View all',
  btnIcon: <IoMdArrowForward />,
  images: [
    {
      src: GalleryImg1,
      original: GalleryImg1,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg2,
      original: GalleryImg2,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg3,
      original: GalleryImg3,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg4,
      original: GalleryImg4,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg5,
      original: GalleryImg5,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg6,
      original: GalleryImg6,
      width: 464,
      height: 412,
    },
    {
      src: GalleryImg7,
      original: GalleryImg7,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg8,
      original: GalleryImg8,
      width: 465,
      height: 412,
    },
  ],
};

export const interviewData = {
  title:
    '“Consider what you desire. Your tattoo artist will never tell you what tattoo to have.”',
  btnText: 'Watch it now',
  btnIcon: <FaPlay />,
};

export const testimonialData = [
  {
    quoteImg: QuoteImg,
    message:
      "The entire team is extremely kind and friendly. They're fantastic. They're great at what they do! And it's unique.They will properly consult with you.",
    name: 'Jack Geoffrey',
    occupation: 'Tattoo Artist',
  },
  {
    quoteImg: QuoteImg,
    message:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam culpa asperiores officia natus dignissimos autem possimus molestias aperiam?',
    name: 'Douglas Hane',
    occupation: 'Tattoo Artist',
  },
];

export const contactData = {
  title: 'Get in touch with me:',
  info: [
    {
      title: 'Kolkata office',
      subtitle:
        'Lorem ipsum dolor sit amet. Ad ipsum fugiat eum consequatur quaerat eum quod error et temporibus ullam sit excepturi quas et quibusdam error. Est iure alias et molestias sint qui quae aperiam',
      address: {
        icon: <FaMapMarkerAlt />,
        name: '83 MB ROAD, BESIDE BIG BAZAR, Birati, Kolkata - 700051 (GIRATI COLLEGE MOD)',
      },
      phone: {
        icon: <FaPhoneAlt />,
        number: '+91 1234576890',
      },
      email: {
        icon: <FaEnvelope />,
        address: 'contact@yourcompany.com',
      },
      link: 'Get location',
    },
    {
      title: 'Mumbai office',
      subtitle:
        'Lorem ipsum dolor sit amet. Ad ipsum fugiat eum consequatur quaerat eum quod error et temporibus ullam sit excepturi quas et quibusdam error. Est iure alias et molestias sint qui quae aperiam',
      address: {
        icon: <FaMapMarkerAlt />,
        name: 'Monterossa, 104, 1st Floor, 90 Feet Rd, Above SBI bank, Near Siddhivinak Ganesh Mandir, Railway Police Colony, Ghatkopar East, Mumbai, Maharashtra 400075',
      },
      phone: {
        icon: <FaPhoneAlt />,
        number: '+91 0987654312',
      },
      email: {
        icon: <FaEnvelope />,
        address: 'contact@yourcompany.com',
      },
      link: 'Get location',
    },
  ],
  form: {
    name: 'Write your name here',
    email: 'Write your email address',
    message: 'Write your messages here',
    btnText: 'Send it',
  },
};

export const footerData = {
  about: {
    title: 'About Sourin tattoo',
    subtitle:
      'Tattoos have their own unique power and magic. They not only beautify the body but also the psyche.',
    address: {
      icon: <FaMapMarkerAlt />,
      name: '123 Park Street, Kolkata',
    },
    phone: {
      icon: <FaPhoneAlt />,
      number: '+91 0000000000',
    },
    email: {
      icon: <FaEnvelope />,
      address: 'contact@yourcompany.com',
    },
  },
  links: {
    title: 'Useful links',
    items: [
      { href: '/', name: 'About me' },
      { href: '/', name: 'My gallery' },
      { href: '/', name: 'My services' },
      { href: '/', name: 'Contact me' },
    ],
  },
  program: {
    title: 'Working Time',
    items: [
      { name: 'Mon - Tue / Appointment' },
      { name: 'Wed - Fri / 10:00 - 9:00pm' },
      { name: 'Sat / 10:00 - 6:00pm' },
      { name: 'Sun / no work on this day' },
    ],
  },
  newsletter: {
    title: 'Newsletter',
    subtitle:
      'Get inspired for your next tattoo. We have curated a library of beautiful tattoos for you to explore.',
    form: {
      placeholder: 'Your email address',
      icon: <FiSend />,
    },
  },
};
